/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Nav_LabelInputs */

const en_notifications_nav_label = /** @type {(inputs: Notifications_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const pl_notifications_nav_label = /** @type {(inputs: Notifications_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Notifications_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_nav_label = /** @type {((inputs?: Notifications_Nav_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Nav_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_nav_label(inputs)
	return en_notifications_nav_label(inputs)
});